module.exports = __webpack_public_path__ + "media/images/drivu_logo_H-d1752ac19da2e741414142dd022ec972.png";